import { render, staticRenderFns } from "./buriedPointIndex.vue?vue&type=template&id=5ff153da"
import script from "./buriedPointIndex.vue?vue&type=script&lang=js"
export * from "./buriedPointIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports